module.exports = {"130184001":"长寿街道","130184101":"化皮镇","130184102":"承安镇","130184103":"正莫镇","130184104":"南大岳镇","130184105":"杜固镇","130184106":"邯邰镇","130184107":"东王镇","130184108":"马头铺镇","130184200":"协神乡","130184201":"木村乡","130184202":"彭家庄回族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130184.json
// module id = 77
// module chunks = 0